import "./About.css";

export default function About() {
  return (
    <>
      <div className="container">
        <div>
          <img className="card-img" src="media/aboutMePic.webp" alt="Me" />
        </div>
        <h4>About me</h4>

        <p>My name is Xavier (Alejandro) Lozano.</p>
        <p>
          I am an ambitious Full stack developer and overall technology
          enthusiast!
        </p>
        <p>
          I first discovered scripting/coding back in High School. I was leaving
          disc drives on an open and close loop at school and shutting down my
          friends' computers before I could write a proper thesis.
        </p>
        <p>
          My interest in programming really took off after being introduced to
          Java, but even more so once I was introduced to website design using
          HTML. Naturally, I became driven to give my websites more funcionality
          by leveraging the power of JavaScript and CSS, and adding further DOM
          manipulation using JQuery somewhere down the line.
        </p>
        <p>
          Since then, my skills have significantly expanded to include most
          languages for front-end and back-end development alike.
        </p>
        <br />

        <h4>Programming history</h4>
        <p>
          My first exposure to programming came in the form of scripting, by
          creating batch files to conveniently lauch multiple programs
          simultaneously. I enrolled myself in a <strong>Java</strong> course
          not long after, where I learned the basics of IO and computer logic.
          My curiosity in computer programming led me to languages such as{" "}
          <strong>Fortran</strong>, <strong>C</strong>, <strong>C++</strong>,
          and <strong>Python</strong>.
        </p>
        <br />

        <h4>Web programming history</h4>
        <p>
          Naturally, I wanted to share my programming knowledge with my friends
          and family, and so I took a course in the basics of web programming.
          In this course, I was introduced to <strong>HTML</strong>,{" "}
          <strong>CSS</strong>, and <strong>JavaScript</strong>. I implemented
          my existing knowledge on programming logic to create beautiful pages
          which I could then share with others.
        </p>
        <p>
          Come 2020, I became even more involved in web development. I began to
          develop back end powered pages with <strong>Express</strong>,{" "}
          <strong>Node</strong>, and <strong>Handlebars</strong> and front end
          powered pages using frameworks such as <strong>Angular</strong> and{" "}
          <strong>React</strong>.
        </p>
        <p>
          I strongly believe that web programming is a field where one is
          constantly learning new things because new tools and frameworks are
          created constantly. It is precicely this aspect of web development
          that I love the most, because I know that a career will always be
          exciting!
        </p>
        <br />

        <h4>Hobbies</h4>
        <p>
          Out of my hobbies, hopping on a Onewheels has to take the cake. Not
          only is it an amazing feeling to effortlessly cruise through your
          favourite places, but as a tech enthusiast, I get to really appreciate
          everything that happens behind the scenes.
        </p>
        <p>
          As a lover of nature and healthy living, I enjoy anything that
          involves spending time outdoors such as hiking, swimming, and biking.
          As well as consistently excercising and keeping track of my diet.
        </p>
        <p>
          I strongly believe in continuous self improvement so I put a lot of
          effort into becoming a better version of myself one step at a time.
        </p>
      </div>
    </>
  );
}
